exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.welcome-content h6[data-v-2f863d31]{margin:20px auto 10px auto;text-align:center;font-weight:400\n}\n.welcome-content h2[data-v-2f863d31]{margin:0 auto;text-align:center;font-weight:400\n}\n.welcome-content p[data-v-2f863d31]{text-align:center;margin:20px 100px;font-weight:300;font-size:14px\n}\n@media (max-width: 1024px){\n.welcome-content p[data-v-2f863d31]{margin:20px 40px\n}\n}\n@media (max-width: 414px){\n.welcome-content p[data-v-2f863d31]{margin:20px 10px\n}\n}\n", ""]);

// exports
